import { Dialog } from "@mui/material"
import type { FC } from "react"

import { AddAssociationLocationContent } from "./AddAssociationLocationContent"
import type { AssociationLocationEditProps } from "./EditAssociationLocationContent"
import { EditAssociationLocationContent } from "./EditAssociationLocationContent"

import DialogHeader from "@/components/common/Modals/DialogHeader"

interface AssociationLocationDialogProps {
  companyProductAssociationId: string
  companyId: string
  productId: number
  customerCodes: string[]
  onClose: () => void
  onSuccess: () => void
  location?: AssociationLocationEditProps
}

export const AssociationLocationDialog: FC<AssociationLocationDialogProps> = ({
  companyProductAssociationId,
  companyId,
  productId,
  customerCodes,
  onClose,
  onSuccess,
  location,
}) => (
  <Dialog open onClose={onClose} maxWidth='sm' fullWidth>
    <DialogHeader title={location ? "Edit Location Association" : "Associate Location"} onClose={onClose} />
    {location ? (
      <EditAssociationLocationContent
        location={location}
        customerCodes={customerCodes}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    ) : (
      <AddAssociationLocationContent
        companyProductAssociationId={companyProductAssociationId}
        companyId={companyId}
        productId={productId}
        customerCodes={customerCodes}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    )}
  </Dialog>
)
